// extracted by mini-css-extract-plugin
export default {"background":"notFound_background__IU2e0"};